import { Cookies } from 'quasar'

export default function getCookies(ssrContext) {
  const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client
  return cookies
}

export { getCookies }
